import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { addClass, find, findAll, hasClass, removeClass, getParent } from '@fretadao/f-js-dom';

application.register('fields-for', class extends Controller {
  static targets = ["fields"]
  static values = {
    keepOriginAndDestination: {
      type: String,
      default: 'false'
    }
  };

  connect() {
    this.#countElements();
    this.#hideUnremoveableElements();
  }

  hide(event) {
    const fieldsWrapper = event.target.closest("[data-fields-for-target='fields']");
    const formEl = event.target.form;

    fieldsWrapper.remove();

    this.#countElements();
    this.#hideUnremoveableElements();

    formEl.dispatchEvent(new Event('change'));
  }

  hideAndRecalculate(event) {
    this.hide(event);

    const routeInfoWrapper = find('[data-b2b-admin-custom-routing-target="routeInfoWrapper"]', this.element);
    const recalculateRouteEvt = new Event('recalculateRoute');

    routeInfoWrapper.dispatchEvent(recalculateRouteEvt);
  }

  add(event) {
    event.preventDefault();

    const addBtnEl = event.target;
    const addBtnWrapperDivEl = addBtnEl.closest('div.grid');
    const fieldsTemplate = addBtnEl.dataset.fields.replace(/new_field/g, new Date().getTime());
    const prevLastFieldsWrapper = this.fieldsTargets.reverse()[0];

    addBtnWrapperDivEl.insertAdjacentHTML('beforebegin', fieldsTemplate);

    const newLastFieldsWrapper = this.fieldsTargets.reverse()[0];
    const prevFields = findAll('input', prevLastFieldsWrapper);
    const newFields = findAll('input', newLastFieldsWrapper);

    prevFields.forEach((field) => {
      const searchTerm = field.getAttribute('class')?.split(' ')?.pop();
      if (!searchTerm) return;

      const targetField = newFields.find((f) => hasClass(f, searchTerm));

      targetField.value = field.value;
      field.value = null;
    });

    this.#countElements();
    this.#hideUnremoveableElements();
  }

  #countElements() {
    const controllerWrapper = this.element;
    const countableElementLabels = findAll('.count-label', controllerWrapper);

    if (countableElementLabels.length > 0) {
      countableElementLabels.forEach((labelEl, index) => {
        const waypointWrapper = getParent(labelEl, 2);
        const indexField = find('input.wp-index-field', waypointWrapper);
        let innerText = index + 1;

        if (index == 0 && countableElementLabels.length > 1) innerText += ' <span class="text-primary italic font-normal">(origem do trajeto)</span>';
        if ((index + 1 == countableElementLabels.length) && countableElementLabels.length > 1) innerText += ' <span class="text-primary italic font-normal">(destino do trajeto)</span>';

        indexField.value = index;
        labelEl.innerHTML = innerText;
      });
    }
  }

  #hideUnremoveableElements() {
    if (this.keepOriginAndDestinationValue == 'false') return;

    const fieldsCollection = findAll('[data-fields-for-target="fields"]', this.element);
    const targetElements = [fieldsCollection[0], fieldsCollection.reverse()[0]];

    fieldsCollection.forEach(fieldset => {
      const destroyEl = find('.remove-waypoint', fieldset);

      if (!destroyEl) return;

      if (targetElements.includes(fieldset)) {
        addClass(destroyEl, 'hidden');
      } else {
        removeClass(destroyEl, 'hidden');
      }
    });
  }
});
